<div class="sub-chrome-container">
    <div class="title-area workflow-draft-title" kendoTooltip>
        <span class="h1-light text-ellipsis" tamDynamicTooltip
            [title]="config.config.name">{{config.config.name}}</span>
        <div *ngIf="showDraftLink" class="draft-link">
            <span class="draft-span" (click)="onClickDraftLink()">A version of this workflow was saved as draft. Click
                to resume editing.</span>
        </div>
    </div>
    <div class="operation-box">
        <button tam-button tamType="tertiary" tamSize="normal" (click)="onCancel()">Cancel</button>
        <button tam-button tamType="secondary" tamSize="normal" (click)="onEditClick()">Edit Details</button>
        <button tam-button tamType="secondary" tamSize="normal" (click)="onSaveAsDraft()"
            [tamLoading]="saveDraftLoading" [disabled]="saveDraftLoading">Save as Draft</button>
        <button tam-button tamType="primary" tamSize="normal" [tamLoading]="saveBtnLoading"
            (click)="onPublish()">Publish</button>
    </div>
</div>